import React, { ReactNode } from "react";
import { IWebsiteBuilderRoot, WEBSITE_BUILDER_ROOT_CLASS_NAME } from "../../../../nodes/root/websiteBuilderRoot";
import { useWebsiteBuilderEditorContext } from "../../../../websiteBuilderEditorContext";
import { useActivePageDomNodeRefMapRegistration } from "../../../../hooks/activePageDomNodeRefMap/useActivePageDomNodeRefMapRegistration";
import { useAppSelector } from "hooks/redux";

interface IWebsiteBuilderRootViewProps {
  node: IWebsiteBuilderRoot;
  header: ReactNode;
  children: ReactNode;
  footer: ReactNode;
}

export function WebsiteBuilderRootView(props: IWebsiteBuilderRootViewProps) {
  const { node, header, children, footer } = props;

  const { activePageDomNodeRefMap } = useWebsiteBuilderEditorContext();
  const activePageDomNodeRefMapRegistration = useActivePageDomNodeRefMapRegistration(node.id, activePageDomNodeRefMap);

  const rootCssVariables = useAppSelector(store => store.websiteBuilderStore.editor.rootCssVariables);

  return (
    <div
      ref={activePageDomNodeRefMapRegistration}
      className={WEBSITE_BUILDER_ROOT_CLASS_NAME}
      style={rootCssVariables}
    >
      {header}
      {children}
      {footer}
    </div>
  );
}
